export interface IBrowser {
    gotoURL(url: string, openOnParent?: boolean): void;
    gotoBack(): void;
    openNewTab(url: string): void;
    reloadPage(): void;
    postMessage(message: any, targetOrigin?: string): void;
    postMessageToParent(message: any, targetOrigin?: string, transfer?: Transferable[]): void;
    postMessageToTop(message: any, targetOrigin?: string): void;
    createMessageChanel(): MessageChannel;
    setOnBeforeUnloadedCallback(callback: Function): void;
    addEventListener(type: string, listener: (data?: any) => void, options?: any): void;
    removeEventListener(type: string, listener: (data?: any) => void, options?: any): void;
    disableDoubleTapToZoom(): void;
    removeAllListeners(): void;
    addTimeout(handler: TimerHandler, timeout?: number): number;
    addInterval(handler: TimerHandler, timeout?: number): number;
    removeTimeout(timeoutID: number): void;
    removeInterval(timeoutID: number): void;
    removeAllTimeouts(): void;
}
